import React from 'react';
import { Construct } from '@carbon/pictograms-react';
import { EmptyState } from 'components/EmptyState';

const EmptyStatePage = () => {
  return (
    <EmptyState>
      <div className="search-emails-no-data--wrapper">
        <Construct />
        <div className="search-emails-empty-state-heading">
          There is no data to display
        </div>
        <div className="search-emails-empty-state-sub-heading">
          Try different filter options
        </div>
      </div>
    </EmptyState>
  );
};

EmptyStatePage.displayName = 'EmptyStatePage';
export default EmptyStatePage;
